import { isNumber } from 'lodash-es';

import { ColorRuleProps } from '../../core/types/color-rule.js';
import {
  buildValidator,
  isRangeOperator,
  Range,
  RANGE_MATCHERS,
} from '../../core/utils/validators.js';
import { NameAccessor } from '../types/treemap.js';

export const isValidRangeColorRule = (range: Range, rule: ColorRuleProps) => {
  const hasValidValueAccessor =
    !rule.valueAccessor ||
    ['name', 'value'].includes(rule.valueAccessor as NameAccessor);

  if (
    !isRangeOperator(rule.comparator) ||
    !isNumber(rule.matchValue) ||
    !hasValidValueAccessor
  ) {
    return false;
  }

  return buildValidator(RANGE_MATCHERS)(
    range,
    rule.comparator,
    rule.matchValue,
  );
};
